// extracted by mini-css-extract-plugin
export var root = "n_p5";
export var wrapper = "n_p6";
export var image = "n_p7 d_s d_v d_S";
export var crop = "n_p8";
export var round = "n_p9";
export var fixedHeight = "n_qb";